import React from 'react'
import styled from 'styled-components'

import Checkbox from 'components/Checkbox'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

const ACKNOWLEDGE_NEW_MESSAGE = "Don't show this customer as \"New\" Customer in my customer list."
const ACKNOWLEDGE_UPDATED_MESSAGE = "Don't show this customer as \"Updated\" Customer in my customer list."
const ACKNOWLEDGE_DUPLICATE_MESSAGE = "Don't show this customer as \"Duplicate\" Customer in my customer list."

type Props = {
  isNewAndUnacknowledged: boolean | null
  isUpdatedAndUnacknowledged: boolean | null
  isDuplicateAndUnacknowledged: boolean | null
  isUpdateAcknowledged: boolean
  piiHomeDuplicateNames: string | null
  piiAcknowledgedAt: string | null
  piiDuplicateAck: boolean | null
  displayCustomerEntry: boolean
  orginalPiiAcknowledgedAt?: string | null
  onChangeCallback: (customerAttributes: object) => void
}

const PiiFlags = (
  {
    isNewAndUnacknowledged,
    isUpdatedAndUnacknowledged,
    isDuplicateAndUnacknowledged,
    isUpdateAcknowledged,
    piiHomeDuplicateNames,
    piiAcknowledgedAt,
    piiDuplicateAck,
    displayCustomerEntry,
    orginalPiiAcknowledgedAt,
    onChangeCallback
  }: Props) => {
  return (
    <S.Container $displayCustomerEntry={displayCustomerEntry}>
      {isDuplicateAndUnacknowledged && (
        <S.DescriptionOfDuplicates>This could be a duplicate account. We have identified that this account has the same home info as "{piiHomeDuplicateNames}".
          You can merge these two accounts by removing the system(s) from one and adding to the other (and then deleting the empty account).
          If these are not duplicates, you can edit this customer to remove the duplicate flag.
        </S.DescriptionOfDuplicates>
      )}

      {isNewAndUnacknowledged && (
        <S.AcknowledgePiiCheckbox
            label={ACKNOWLEDGE_NEW_MESSAGE}
            checked={piiAcknowledgedAt != null}
            onChange={() => onChangeCallback({ piiAcknowledgedAt: !piiAcknowledgedAt ? new Date().toUTCString() : null })}
        />
      )}

      {isUpdatedAndUnacknowledged && (
        <S.AcknowledgePiiCheckbox
          label={ACKNOWLEDGE_UPDATED_MESSAGE}
          checked={!isUpdateAcknowledged}
          onChange={() => onChangeCallback(
            { piiAcknowledgedAt: isUpdateAcknowledged ? new Date().toUTCString() : orginalPiiAcknowledgedAt }
          )}
        />
      )}

      {isDuplicateAndUnacknowledged && (
        <S.AcknowledgePiiCheckbox
          label={ACKNOWLEDGE_DUPLICATE_MESSAGE}
          checked={piiDuplicateAck || false}
          onChange={() => onChangeCallback({ piiDuplicateAck: !piiDuplicateAck }
          )}
        />
      )}
    </S.Container>
  )
}

export default PiiFlags

const S = {
  Container: styled.div<{ $displayCustomerEntry: boolean }>`
    border-bottom: ${props => props.$displayCustomerEntry ? 'none' : '1px solid ' + color('divider')};
    padding-bottom: 10px;
    margin-bottom: 20px;

    @media ${screenSize.small} {
      margin-bottom: 00px;
    }
  `,
  DescriptionOfDuplicates: styled.div`
    padding: 0 15px;
    color: ${color('secondaryText')}  
  `,
  AcknowledgePiiCheckbox: styled(Checkbox)`
    display: flex;
    align-items: baseline;

    @media ${screenSize.small} {
      padding: 15px 15px 15px 0px;

      > label {
        white-space: normal;
      }
    }
  `,
  Explanation: styled.p`
    margin-top: 13px;
  `
}
